import { useLayoutEffect, useState, type ReactNode, type RefObject } from "react";
import { createPortal } from "react-dom";

export function useEmailBuilderCanvasRailPortalHost(
  enabled: boolean,
  frameRef: RefObject<HTMLElement | null>,
): HTMLElement | null {
  const [host, setHost] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    if (!enabled) {
      setHost(null);
      return;
    }

    const frameNode = frameRef.current;
    const canvasHost = frameNode?.closest(".email-builder-canvas");
    const mainCanvas = canvasHost?.querySelector("#main-canvas");
    const scrollTrack =
      mainCanvas instanceof HTMLElement
        ? mainCanvas.querySelector(".editor-canvas-scroll__track")
        : null;
    const nextHost =
      canvasHost instanceof HTMLElement &&
      canvasHost.classList.contains("email-builder-canvas--mobile-layout")
        ? canvasHost
        : scrollTrack instanceof HTMLElement
          ? scrollTrack
          : null;
    setHost(nextHost);
  }, [enabled, frameRef]);

  return host;
}

export function renderEmailBuilderCanvasRailPortal(
  node: ReactNode,
  host: HTMLElement | null,
): ReactNode {
  if (node === null) {
    return null;
  }

  return host !== null ? createPortal(node, host) : node;
}
